import { Branding, DisabledPrompt, useModel } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import SettingsPageWrapper from "components/shared/containers/SettingsPageWrapper";
import BaseToggleView from "components/shared/views/BaseToggleView";
import { UIPrimaryButton } from "components/ui/UIButton";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function PersonalInformationPage
 * @return {React.Component}
 * @exported true
 * @description The main component for PersonalInformationPage
 */

export default function PersonalInformationPage(props) {
  const { user, settings } = useModel();

  const { name, email, phoneRevealed } = user;
  const { fiName } = settings;

  return(
    <SettingsPageWrapper className="personal-information-page">
      <MainContentContainer header={<MainContentHeader text="Personal Information" icon="LeftChevronIcon" />}>

          <p>How would you like to be contacted about your card activities?</p>
          <FormContainer>
            <Branding id="email_chw23" value="true">
              <BaseToggleView 
                mainText="Email" 
                subText=""
                toggleBlock ={
                  <FormRow className="indented-form-row bottom-border">
                    <p>Email Address</p>
                    <p className="sub-text">{ email }</p>
                  </FormRow>
                } />
            </Branding>

            <Branding id="sms_chw23" value="true">
              <BaseToggleView 
                mainText="SMS" 
                subText=""
                toggleBlock ={
                  <FormRow className="indented-form-row bottom-border">
                    <p>Mobile Phone Number</p>
                    <p className="sub-text">{ phoneRevealed }</p>
                  </FormRow>
                } />
            </Branding>

            <FormRow className="name-form-row bottom-border">
                <p>Name</p>
                <p className="sub-text">{ name }</p>
              </FormRow>
              <div className="flex-container flex-horizontal align-center-container info-container">
                <SVGAsset id="InformationIcon" className="set-width left-inline-icon" />
                <p className="flex-width">Saving these preferences verifies that you agree to receive alerts from { fiName }. Message and data rates may apply.</p>
              </div>
              <FormButtonContainer>
                <DisabledPrompt>
                  <UIPrimaryButton text="Save" />
                </DisabledPrompt>
              </FormButtonContainer>
          </FormContainer>
      </MainContentContainer>
    </SettingsPageWrapper>
  );
}